module.exports = __webpack_public_path__ + "img/Rectangle_19P.f6462318.png";